import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  Box,
  Divider,
  Typography,
  Checkbox,
  Button,
  makeStyles,
} from "@material-ui/core";
import Header from "./Header";

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
  },
  container: {
    padding: theme.spacing(4),
    paddingTop: 0,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
}));
const initModulesPermissions = [
  {
    moduleId: 1,
    name: "Clients",
    modulePage: [
      {
        moduleId: 1,
        modulePageId: 1,
        name: "List",
        actionCommonName: "View|Add|Edit|Delete",
        actionAdditionalName: "",
      },
    ],
    groupModulePageAction: [
      {
        groupModulePageActionId: 1,
        modulePageId: 1,
        access: true,
        actionCommonPermission: "View:1|Add:0|Edit:0|Delete:0",
        actionAdditionalPermission: "",
      },
    ],
  },
  {
    moduleId: 2,
    name: "Forms",
    modulePage: [
      {
        moduleId: 2,
        modulePageId: 1,
        name: "List",
        actionCommonName: "View|Add|Edit|Delete",
        actionAdditionalName: "Publish|Assign Scores|Copy|Preview",
      },
    ],
    groupModulePageAction: [
      {
        groupModulePageActionId: 1,
        modulePageId: 1,
        access: false,
        actionCommonPermission: "View:1|Add:1|Edit:0|Delete:0",
        actionAdditionalPermission:
          "Publish:1|Assign Scores:0|Copy:1|Preview:0",
      },
    ],
  },
  {
    moduleId: 3,
    name: "Terms",
    modulePage: [
      {
        moduleId: 3,
        modulePageId: 1,
        name: "List",
        actionCommonName: "View|Add|Edit|Delete",
        actionAdditionalName: "Assign Teams|Deactivate",
      },
    ],
    groupModulePageAction: [
      {
        groupModulePageActionId: 1,
        modulePageId: 1,
        access: true,
        actionCommonPermission: "View:0|Add:0|Edit:0|Delete:0",
        actionAdditionalPermission: "Assign Teams:1|Deactivate:1",
      },
    ],
  },
  {
    moduleId: 4,
    name: "Teams",
    modulePage: [
      {
        moduleId: 4,
        modulePageId: 1,
        name: "List",
        actionCommonName: "View|Add|Edit|Delete",
        actionAdditionalName: "Terms|Notes",
      },
    ],
    groupModulePageAction: [
      {
        groupModulePageActionId: 1,
        modulePageId: 1,
        access: true,
        actionCommonPermission: "View:0|Add:0|Edit:0|Delete:0",
        actionAdditionalPermission: "Terms:1|Notes:1",
      },
    ],
  },
  {
    moduleId: 5,
    name: "General Settings",
    modulePage: [
      {
        moduleId: 5,
        modulePageId: 1,
        name: "Configure Tenant",
        actionCommonName: "View|Add|Edit|Delete",
        actionAdditionalName: "",
      },
      {
        moduleId: 5,
        modulePageId: 2,
        name: "Configure Terms",
        actionCommonName: "View|Add|Edit|Delete",
        actionAdditionalName: "",
      },
      {
        moduleId: 5,
        modulePageId: 3,
        name: "Manage Groups",
        actionCommonName: "View|Add|Edit|Delete",
        actionAdditionalName: "Group Permissions|Staff",
      },
      {
        moduleId: 5,
        modulePageId: 4,
        name: "Manage Event Types",
        actionCommonName: "View|Add|Edit|Delete",
        actionAdditionalName: "",
      },
    ],
    groupModulePageAction: [
      {
        groupModulePageActionId: 1,
        modulePageId: 1,
        access: true,
        actionCommonPermission: "View:0|Add:0|Edit:0|Delete:0",
        actionAdditionalPermission: "",
      },
      {
        groupModulePageActionId: 2,
        modulePageId: 2,
        access: true,
        actionCommonPermission: "View:0|Add:0|Edit:0|Delete:0",
        actionAdditionalPermission: "",
      },
      {
        groupModulePageActionId: 3,
        modulePageId: 3,
        access: false,
        actionCommonPermission: "View:0|Add:0|Edit:0|Delete:0",
        actionAdditionalPermission: "Group Permissions:1|Staff:1",
      },
      {
        groupModulePageActionId: 4,
        modulePageId: 4,
        access: false,
        actionCommonPermission: "View:0|Add:0|Edit:0|Delete:0",
        actionAdditionalPermission: "",
      },
    ],
  },
];

const transformPermissions = (data) => {
  return data.map((mod) => {
    return {
      ...mod,
      modulePage: mod.modulePage.map((page) => {
        const action = mod.groupModulePageAction.find(
          (a) => a.modulePageId === page.modulePageId
        );

        const parsePermissions = (names, values) => {
          if (!names) return [];
          return names.split("|").map((name) => ({
            permission: name.trim(),
            checked: values?.includes(`${name}:1`) || false,
          }));
        };

        return {
          ...page,
          permission: page.name,
          access: action?.access || false,
          common: parsePermissions(
            page.actionCommonName,
            action?.actionCommonPermission || ""
          ),
          additional: parsePermissions(
            page.actionAdditionalName,
            action?.actionAdditionalPermission || ""
          ),
        };
      }),
    };
  });
};
const extractCommonHeaders = (data) => {
  //removes repeated values automatically by using a Set
  const headerSet = new Set();
  data.forEach((mod) => {
    mod.modulePage.forEach((page) => {
      if (page.actionCommonName) {
        page.actionCommonName.split("|").forEach((perm) => {
          headerSet.add(perm.trim());
        });
      }
    });
  });
  return Array.from(headerSet);
};

const commonHeaders = extractCommonHeaders(initModulesPermissions);

const GroupPermissionUI = () => {
  const classes = useStyles();
  const [modulesPermissions, setModulesPermissions] = useState(
    transformPermissions(initModulesPermissions)
  );

  const maxAdditional = Math.max(
    ...modulesPermissions.flatMap((mod) =>
      mod.modulePage.map((p) => p.additional.length)
    )
  );

  const flatRows = modulesPermissions.flatMap((mod) =>
    mod.modulePage.map((p, index) => ({
      moduleId: mod.moduleId,
      moduleName: mod.name,
      page: p,
      pageCount: mod.modulePage.length,
      isFirstPage: index === 0,
    }))
  );

  const handleToggle = (moduleId, pageId, section, permName) => {
    setModulesPermissions((prev) =>
      prev.map((mod) => {
        if (mod.moduleId !== moduleId) return mod;
        return {
          ...mod,
          modulePage: mod.modulePage.map((pg) => {
            if (pg.modulePageId !== pageId) return pg;

            // Toggle access
            if (section === "access") {
              return {
                ...pg,
                access: !pg.access,
              };
            }

            // Toggle common or additional permissions
            const updated = pg[section].map((perm) =>
              perm.permission === permName
                ? { ...perm, checked: !perm.checked }
                : perm
            );
            return { ...pg, [section]: updated };
          }),
        };
      })
    );
  };
  const handleSave = () => {
    const result = modulesPermissions.map((mod) => {
      return {
        moduleId: mod.moduleId,
        modulePage: mod.modulePage,
        name: mod.name,
        groupModulepageAction: mod.modulePage.map((pg) => {
          const actionCommonPermission = pg.common
            .map((perm) => `${perm.permission}:${perm.checked ? 1 : 0}`)
            .join("|");

          const actionAdditionalPermission = pg.additional
            .map((perm) => `${perm.permission}:${perm.checked ? 1 : 0}`)
            .join("|");

          return {
            modulePageId: pg.modulePageId,
            access: pg.access || false,
            actionCommonPermission,
            actionAdditionalPermission,
          };
        }),
      };
    });

    console.log("Prepared data for save:", result);
  };

  const cellStyle = { borderRight: "1px solid #ccc" };
  const cellStyleAdditional = {
    borderRight: "1px solid #ccc",
    textAlign: "left",
  };

  return (
    <div className={classes.root}>
      <Header
        breadcrumbs={[
          { label: "Group 1", link: null },
          { label: "Permissions", link: null },
        ]}
      />
      <div className={classes.container}>
        <Box mt={2} mb={2} textAlign="center">
          <Typography variant="body1" style={{ fontWeight: 600 }}>
            Group Permissions
          </Typography>
        </Box>
        <Divider />
        <Box pb={4} />

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ border: "1px solid #e0e0e0", boxShadow: "none" }}
        >
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell rowSpan={2} sx={cellStyle} align="center">
                  <strong>Module</strong>
                </TableCell>
                <TableCell rowSpan={2} sx={cellStyle} align="center">
                  <strong>Page</strong>
                </TableCell>
                <TableCell
                  colSpan={commonHeaders.length}
                  align="center"
                  sx={cellStyle}
                >
                  <strong>Common Permissions</strong>
                </TableCell>
                <TableCell rowSpan={2} align="center">
                  <strong>Additional Permissions</strong>
                </TableCell>
              </TableRow>
              <TableRow>
                {commonHeaders.map((perm) => (
                  <TableCell key={perm} align="center" sx={cellStyle}>
                    <strong>{perm}</strong>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {flatRows.map((row) => (
                <TableRow key={`${row.moduleId}-${row.page.modulePageId}`}>
                  {row.isFirstPage && (
                    <TableCell rowSpan={row.pageCount} sx={cellStyle}>
                      {row.moduleName}
                    </TableCell>
                  )}
                  <TableCell sx={cellStyle}>
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        size="small"
                        checked={row.page.access}
                        onChange={() =>
                          handleToggle(
                            row.moduleId,
                            row.page.modulePageId,
                            "access"
                          )
                        }
                      />
                      {row.page.permission}
                    </Box>
                  </TableCell>

                  {commonHeaders.map((perm) => (
                    <TableCell key={perm} align="center" sx={cellStyle}>
                      <Checkbox
                        size="small"
                        checked={
                          row.page.common.find((c) => c.permission === perm)
                            ?.checked || false
                        }
                        onChange={() =>
                          handleToggle(
                            row.moduleId,
                            row.page.modulePageId,
                            "common",
                            perm
                          )
                        }
                      />
                    </TableCell>
                  ))}
                  <TableCell align="center">
                    {row.page.additional.length === 0 ? (
                      <>None</>
                    ) : (
                      row.page.additional.map((perm) => (
                        <Box
                          key={perm.permission}
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            size="small"
                            checked={perm.checked}
                            onChange={() =>
                              handleToggle(
                                row.moduleId,
                                row.page.modulePageId,
                                "additional",
                                perm.permission
                              )
                            }
                          />
                          {perm.permission}
                        </Box>
                      ))
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box mt={4} textAlign="center">
          <Button
            variant="contained"
            className={classes.buttonStyle}
            onClick={handleSave}
          >
            Save
          </Button>
          <Button
            variant="text"
            color="primary"
            className={classes.outlinedButtonStyle}
          >
            Cancel
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default GroupPermissionUI;
